<div class="tab-menu">
  @for (tab of tabs; track tab) {
    <div
      class="tab-menu__item"
      [class.active]="activeTab === tab.key"
      [class.disabled]="tab.disabled"
      (click)="onTabSelect(tab)">
      <div class="tab-menu__menu-item">
        <i class="fa-regular" [class]="tab.iconClass"></i>
        <span class="tab-menu-item-text">
          {{ tab.label }} {{ tab.number ? '(' + tab.number + ')' : '' }}
        </span>
      </div>
      <div class="tab-menu__active-state"></div>
    </div>
  }
</div>
